import React from "react";
import TopbarUserContainer from "./TopbarUserContainer";
import TopbarLeftContainer from "./TopbarLeftContainer";

const GlobalTopbar = () => {
  return (
    <div className="row m-0 pe-3 topbar system-tob-bar">
      <div className="col-12  d-flex justify-content-between align-items-center">
        <TopbarLeftContainer />
        <TopbarUserContainer />
      </div>
    </div>
  );
};

export default GlobalTopbar;
